import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, } from 'reactstrap';
import ChargeDocumentForm from '../Forms/ChargeDocumentForm';

const ChargeDocumentModal = ({ data, isOpen, handleToggleModal }) => {
    return (
        <div>
            <Modal
                isOpen={isOpen}
                toggle={() => handleToggleModal()}
                size='lg'
                className='border-0'
                modalClassName='modal fade zoomIn'
                backdrop={'static'}
                centered={true}
            >
                <ModalHeader toggle={handleToggleModal}>Cargar Documento Transferencia</ModalHeader>
                <ModalBody className=''>
                    <div className='mt-2'>
                        <ChargeDocumentForm
                            isOpen={isOpen}
                            data={data}
                            handleToggleModal={handleToggleModal}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default ChargeDocumentModal;